/* tslint:disable */
/* eslint-disable */
/**
 * Clients API
 * API des listes de clients (personnes ayant au moins un contrat)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClientListItem } from './ClientListItem';
import {
    ClientListItemFromJSON,
    ClientListItemFromJSONTyped,
    ClientListItemToJSON,
    ClientListItemToJSONTyped,
} from './ClientListItem';

/**
 * 
 * @export
 * @interface GetClientListResponse
 */
export interface GetClientListResponse {
    /**
     * 
     * @type {number}
     * @memberof GetClientListResponse
     */
    totalCount: number;
    /**
     * 
     * @type {Array<ClientListItem>}
     * @memberof GetClientListResponse
     */
    items: Array<ClientListItem>;
}

/**
 * Check if a given object implements the GetClientListResponse interface.
 */
export function instanceOfGetClientListResponse(value: object): value is GetClientListResponse {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetClientListResponseFromJSON(json: any): GetClientListResponse {
    return GetClientListResponseFromJSONTyped(json, false);
}

export function GetClientListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetClientListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'items': ((json['items'] as Array<any>).map(ClientListItemFromJSON)),
    };
}

export function GetClientListResponseToJSON(json: any): GetClientListResponse {
    return GetClientListResponseToJSONTyped(json, false);
}

export function GetClientListResponseToJSONTyped(value?: GetClientListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'items': ((value['items'] as Array<any>).map(ClientListItemToJSON)),
    };
}

